import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { motion } from 'framer-motion';

const HeroSection = ({ onStartNow }) => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                pt: { xs: 15, md: 20 },
                pb: { xs: 8, md: 10 },
                position: 'relative',
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
            }}
        >
            {/* Background Image with Overlay */}
            <Box
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    zIndex: 0,
                }}
            >
                <Box
                    component="img"
                    src={require('../../assets/images/hero_bg.png')}
                    alt="Cyber Grid"
                    sx={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        opacity: 0.4, // Subtle visibility
                        filter: 'blur(2px)', // Soften it slightly
                    }}
                />
                {/* Gradient Overlay for Fade */}
                <Box
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        background: theme.palette.mode === 'dark'
                            ? 'linear-gradient(to bottom, rgba(5,5,5,0.2) 0%, rgba(5,5,5,1) 90%)'
                            : 'linear-gradient(to bottom, rgba(248,250,252,0.2) 0%, rgba(248,250,252,1) 90%)',
                    }}
                />
            </Box>

            <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>

                {/* 1. Header Section */}
                <Box
                    component={motion.div}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    sx={{ mb: 4 }}
                >
                    <Box sx={{ mb: 2, display: 'inline-block', p: '6px 16px', borderRadius: '50px', background: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.05)', border: `1px solid ${theme.palette.primary.main}40` }}>
                        <Typography variant="subtitle2" sx={{ color: theme.palette.primary.main, fontWeight: 700, letterSpacing: '0.15em', textTransform: 'uppercase', fontSize: '0.75rem' }}>
                            Web3 Advertising Evolved
                        </Typography>
                    </Box>

                    <Typography
                        variant="h1"
                        sx={{
                            fontSize: { xs: '2.5rem', md: '5rem' },
                            fontWeight: 800,
                            lineHeight: 1.1,
                            mb: 2,
                            background: theme.palette.mode === 'dark'
                                ? 'linear-gradient(180deg, #FFFFFF 0%, #a5a5a5 100%)'
                                : 'linear-gradient(180deg, #0f172a 0%, #475569 100%)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            letterSpacing: '-0.03em',
                        }}
                    >
                        Transform Your Reach
                    </Typography>

                    <Typography
                        variant="h2"
                        sx={{
                            fontSize: { xs: '1.2rem', md: '2rem' },
                            fontWeight: 400,
                            color: '#00F0FF',
                            mb: 4,
                        }}
                    >
                        The Future of Decentralized Promotion
                    </Typography>
                </Box>

                {/* 2. Description & CTA (Banner Removed) */}
                <Box
                    component={motion.div}
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.2, duration: 0.8 }}
                    sx={{ maxWidth: '700px', margin: '0 auto' }}
                >
                    <Typography
                        variant="body1"
                        sx={{
                            color: theme.palette.text.secondary,
                            mb: 6,
                            lineHeight: 1.7,
                            fontSize: '1.2rem',
                            fontWeight: 400,
                        }}
                    >
                        Experience the most effective way to advertise in the Web3 space.
                        Whether you are a project looking for exposure or a viewer seeking rewards,
                        Trend Ads provides a seamless, transparent, and highly engaging ecosystem.
                    </Typography>

                    <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
                        <Button
                            variant="contained"
                            color="primary"
                            size="large"
                            onClick={() => {
                                window.location.href = '/login';
                            }}

                            component={motion.button}
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                            sx={{
                                px: 6,
                                py: 1.5,
                                fontSize: '1.1rem',
                                boxShadow: '0 0 30px rgba(0,240,255,0.3)',
                                borderRadius: '12px'
                            }}
                        >
                            Start Now
                        </Button>
                        <Button
                            variant="outlined"
                            size="large"
                            sx={{
                                px: 6,
                                py: 1.5,
                                fontSize: '1.1rem',
                                color: theme.palette.text.primary,
                                borderColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)',
                                borderRadius: '12px',
                                '&:hover': {
                                    borderColor: theme.palette.text.primary,
                                    background: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.05)',
                                }
                            }}
                            onClick={() => window.open('https://trendcreator.io/#products', '_blank')}
                        >
                            Ecosystem
                        </Button>
                    </Box>
                </Box>
            </Container>
        </Box>
    );
};

export default HeroSection;
